import React, { SVGProps } from 'react';

const SortIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M12.1719 15.1758L12.1719 2.17578" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.17188 1.50781L4.17187 14.6746" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7.17183 11.8281L3.99764 15.0023L0.823441 11.8281"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.1718 4.3516L11.9976 1.17741L8.82344 4.3516"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SortIcon;
